export function Panel({ title, meta, children }) {
  return (
    <section className="card">
      <div className="card-head">
        <h2>{title}</h2>
        {meta && <span className="card-meta">{meta}</span>}
      </div>
      {children}
    </section>
  );
}

export function Empty({ children }) {
  return <p className="card-empty">{children}</p>;
}

export function Loading() {
  return <p className="card-empty">Loading…</p>;
}

export function Failed({ error }) {
  return <p className="card-error">{error}</p>;
}

export function Bars({ rows, format }) {
  const max = Math.max(...rows.map((r) => r.value), 0);
  if (!max) return null;

  return (
    <div className="bars">
      {rows.map((row) => (
        <div
          className="barrow"
          key={row.label}
          title={`${row.label} · ${format ? format(row.value) : row.value}`}
        >
          <span className="barrow-label">{row.label}</span>
          <span className="barrow-track">
            <span className="barrow-fill" style={{ width: `${Math.max((row.value / max) * 100, 1.5)}%` }} />
          </span>
          <span className="barrow-value">{format ? format(row.value) : row.value}</span>
        </div>
      ))}
    </div>
  );
}

export function Columns({ rows, format }) {
  const max = Math.max(...rows.map((r) => r.value), 0);
  if (!max) return null;

  return (
    <div className={`columns${rows.length > 12 ? " is-dense" : ""}`}>
      {rows.map((row) => {
        const empty = !row.value;
        const label = format ? format(row.value) : String(row.value);

        return (
          <div className="col" key={row.label} title={`${row.tooltip ?? row.label} · ${label}`}>
            <span className="col-track">
              <span className="col-bar" style={{ height: empty ? "2px" : `${Math.max((row.value / max) * 100, 3)}%` }}>
                {!empty && <span className="col-value">{label}</span>}
                <span className={`col-fill${empty ? " is-empty" : ""}`} />
              </span>
            </span>
            <span className="col-label">{row.label}</span>
          </div>
        );
      })}
    </div>
  );
}
